/**
 * แปลงค่าจากช่อง `datetime-local` เป็น ISO-8601 ที่ contract รับ
 *
 * ตัวอย่างใน `docs/API_CONTRACT.md` เขียน `planned_start_date` เป็น
 * `"2026-10-01T08:00:00+07:00"` — **มี offset ติดมาด้วยเสมอ** ส่วนช่อง
 * `datetime-local` ของเบราว์เซอร์คืนค่าแบบไม่มีโซนเวลา (`2026-10-01T08:00`)
 *
 * offset ที่เติมเข้าไปมาจาก `lib/businessTime.ts` ซึ่งตรึงไว้ที่เขตเวลาของโรงงาน
 * ตาม **D-055** ไม่ใช่เขตเวลาของเครื่องผู้ใช้ — เวลาที่ผู้ใช้พิมพ์ถือเป็นเวลาของ
 * โรงงานเสมอ
 *
 * ⚠️ ฉบับแรกของไฟล์นี้อ่าน offset จาก `getTimezoneOffset()` พร้อมเหตุผลว่าค่าคงที่
 * "จะผิดทันทีที่มีใครเปิดหน้าจอจากอีกโซนเวลา" — เหตุผลนั้นฟังดูดีแต่กลับด้านกับ
 * D-055: วันที่วางแผนผลิตเป็นข้อเท็จจริงของโรงงาน ถ้ามันขึ้นกับนาฬิกาของคนกรอก
 * แผนเดียวกันที่กรอกจากสองเครื่องจะกลายเป็นสองกำหนดเวลา
 *
 * ไม่มีการปัด ไม่มีการเดาค่าที่ผู้ใช้ไม่ได้กรอก — ค่าที่อ่านไม่ออกคืน `null` แล้ว
 * ฟอร์มเป็นผู้บอกว่ากรอกไม่ครบ
 */

import { businessMinuteToIso } from '../businessTime';

/**
 * `2026-10-01T08:00` → `2026-10-01T08:00:00+07:00` — เสมอ ไม่ว่าเครื่องอยู่โซนใด
 *
 * คืน `null` เมื่ออ่านไม่ออก รวมถึงวันที่ที่ไม่มีอยู่จริง (`2026-02-31`) ซึ่ง `Date`
 * จะเลื่อนให้เองเงียบ ๆ ถ้าไม่ตรวจ
 */
export function localInputToIso(value: string): string | null {
  return businessMinuteToIso(value.trim());
}

/**
 * `planned_end_date` ต้องหลัง `planned_start_date` — เทียบเป็นจุดเวลาจริง
 *
 * เทียบด้วย `Date.parse` บนสตริงที่ **มี offset ติดมาแล้ว** จึงเป็นการเทียบ instant
 * ไม่ใช่การเทียบข้อความ และไม่ขึ้นกับเครื่องที่รันโค้ดนี้
 */
export function isEndAfterStart(startIso: string, endIso: string): boolean {
  const start = Date.parse(startIso);
  const end = Date.parse(endIso);
  if (Number.isNaN(start) || Number.isNaN(end)) {
    return false;
  }
  return end > start;
}
